import { post } from './request'

export function homeStats(data = {}) {
  const payload = {}
  const projectId = Number(data.project_id)
  if (projectId > 0) payload.project_id = projectId
  return post('/api/Home/Stats', payload)
}
